export interface PreRatingThreshold {
  id: string | number;
  packageType?: string;
  dominantMode?: string;
  dominantModeRatio?: number;
  thresholdProfitRate?: number;
  sampleOrderCount?: number;
  modeBreakdown?: any;
  statsStartedAt?: string;
  statsEndedAt?: string;
  generatedAt?: string;
  createdAt?: string;
  updatedAt?: string;
  created_at?: string;
  updated_at?: string;
}

export const PreRatingThresholdLabels = {
  packageType: '套餐类型',
  dominantMode: '主流业务模式',
  dominantModeRatio: '主流模式占比',
  thresholdProfitRate: '利润阈值',
  thresholdProfitRateRaw: '利润阈值(小数)',
  sampleOrderCount: '样本订单数',
  statsStartedAt: '统计开始时间',
  statsEndedAt: '统计结束时间',
  generatedAt: '阈值生成时间',
};
